/**
 * Converts a hex color code to an rgba string with the given opacity.
 * @param hex
 * @param opacity
 * @returns
 */
export const hexToRgba = (hex: string, opacity: number): string => {
  hex = hex.replace('#', '')
  const r = Number.parseInt(hex.substring(0, 2), 16)
  const g = Number.parseInt(hex.substring(2, 4), 16)
  const b = Number.parseInt(hex.substring(4, 6), 16)

  return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity + ')'
}
